var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "AwardIcon",
      "size": "30"
    }
  }), _vm._v(" " + _vm._s(_vm.isEdit ? 'Editar' : 'Adicionar') + " Pontos Manuais ")], 1)]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ArrowLeftIcon",
      "size": "16"
    }
  }), _vm._v(" Voltar ")], 1)], 1)], 1)], 1)], 1)], 1), _c('b-card', [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escola *",
      "label-for": "escola"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "escola",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.schoolOptions,
      "value": "id",
      "label": "name",
      "placeholder": "Selecione uma escola",
      "disabled": _vm.isEdit
    },
    on: {
      "input": _vm.onSchoolChange
    },
    model: {
      value: _vm.form.escola,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "escola", $$v);
      },
      expression: "form.escola"
    }
  }), _vm.errors.escola ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.escola))]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Turma *",
      "label-for": "turma"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "turma",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.classroomOptions,
      "value": "id",
      "label": "name",
      "placeholder": "Selecione uma turma",
      "disabled": !_vm.form.escola || _vm.isEdit
    },
    on: {
      "input": _vm.onClassroomChange
    },
    model: {
      value: _vm.form.turma,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "turma", $$v);
      },
      expression: "form.turma"
    }
  }), _vm.errors.turma ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.turma))]) : _vm._e()], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Alunos *",
      "label-for": "alunos"
    }
  }, [_c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "id": "alunos",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.studentOptions,
      "value": "id",
      "label": "fullName",
      "multiple": "",
      "closeOnSelect": false,
      "placeholder": "Selecione os alunos",
      "disabled": !_vm.form.turma
    },
    model: {
      value: _vm.form.alunos,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "alunos", $$v);
      },
      expression: "form.alunos"
    }
  }), _c('div', {
    staticClass: "d-flex align-items-center flex-wrap gap-2"
  }, [_vm.form.turma && _vm.studentOptions.length > 0 ? _c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm",
      "disabled": _vm.form.alunos.length === _vm.studentOptions.length
    },
    on: {
      "click": _vm.selectAllStudents
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "CheckSquareIcon",
      "size": "14"
    }
  }), _vm._v(" Selecionar Todos da Turma ")], 1) : _vm._e(), _vm.form.alunos.length > 0 ? _c('b-button', {
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    },
    on: {
      "click": _vm.clearAllStudents
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "XIcon",
      "size": "14"
    }
  }), _vm._v(" Limpar ")], 1) : _vm._e()], 1), _vm.errors.alunos ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.alunos))]) : _vm._e(), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Selecione um ou mais alunos "), _vm.form.alunos.length > 0 ? _c('span', [_vm._v(" (" + _vm._s(_vm.form.alunos.length) + " selecionado" + _vm._s(_vm.form.alunos.length > 1 ? 's' : '') + ") ")]) : _vm._e()])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Desafio *",
      "label-for": "motivo"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "motivo",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "options": _vm.motivoOptions,
      "placeholder": "Selecione um desafio"
    },
    model: {
      value: _vm.form.motivo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "motivo", $$v);
      },
      expression: "form.motivo"
    }
  }), _vm.errors.motivo ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.motivo))]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pontuação *",
      "label-for": "pontuacao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "pontuacao",
      "type": "number",
      "min": "0",
      "max": "10",
      "step": "0.1",
      "placeholder": "Digite a pontuação (0 a 10)"
    },
    model: {
      value: _vm.form.pontuacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pontuacao", _vm._n($$v));
      },
      expression: "form.pontuacao"
    }
  }), _vm.errors.pontuacao ? _c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.pontuacao))]) : _vm._e(), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Pontuação de 0 a 10")])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": _vm.isSubmitting
    }
  }, [_vm.isSubmitting ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isSubmitting ? 'Salvando...' : 'Salvar') + " ")], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }